
import ProjectCard from "../PageLayout/ProjectCard";
import ProjectButton from "../Utils/ProjectButton";
import ProjectHeader from "./ProjectHeader";
import sharedStyles from "./shared.module.css"
import { ProjectType } from "../Utils/ProjectType.ts";

export default function CJI2(){




    return (
        <ProjectCard projectName={'CJI2'}>

            <ProjectHeader title={"CJI INFO WEBSITE"} subTitle={"DJAZE Project"} projectType={ProjectType.Code} subTitleInfo="A tech friend group where we share knowledge and build passion projects together." subTitleInfoLeft={true} />

            <p>
                Event information site for Craig Jones’ jiu-jitsu tournament, built as a collaborative DJAZE project with Zaz and my friend Dave: a Software Engineer and DevOps wizard. 
            </p>

            <p>
                The app is a <strong>React/TypeScript</strong> frontend using <strong>React Router</strong>React Router and <strong>React Query</strong>, consuming data hosted on <strong>Cloudflare R2</strong>. 
            </p>

            <p>
                Dave and I worked on the frontend together, and he also set up slick Cloudflare pull request preview links (which I now want on every project!). Zaz handled the backend, automating data entry and deploying everything to <strong>Cloudflare R2</strong> via <strong>GitHub Actions</strong>.
            </p>

            <div >
                <img src="/images/cji2.png" alt="Display of Arthurlytics" className={sharedStyles.image} />
            </div>
            <br />
            <div className={sharedStyles.links}>
                <ProjectButton link="https://staging.cji2.info/" name={"Check it out"} />

                <ProjectButton name={"Code"} disabled={true} reason="We’ve decided to keep this project private for now, but I’d be happy to chat about it on LinkedIn if you’re curious!" />
                
            </div>
        </ProjectCard>
    );
}